import React from 'react';
import { Col, Form, Row, Typography, Select } from 'antd';
import uuid from 'react-uuid';
import { useTranslation } from 'react-i18next';
import Helpers from '../../../../../../../helpers';

const { Option } = Select;

const BrandSection = ({ brands, isView }) => {
  const { t } = useTranslation();

  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Brand')}</Typography.Title>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Brand')} name='brand_id'>
          <Select
            {...Helpers.addSearchProps()}
            placeholder={t('Brand')}
            disabled={isView}
          >
            <Option value=''>{t('Selezioni opzione')}</Option>
            {brands && brands.map((brand) => (
              <Option key={uuid()} value={brand.value}>
                {brand.title} ({brand?.shopping_center_title || ''} )
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(BrandSection);


